import FileSaver from "file-saver";
import {Message} from "element-ui";

export default class fileSave {
    /**
     * 导出Pdf文件
     * @param {*} res   文件流
     * @param {*} name  文件名
     */
    static getPdf(res, name) {
        try {
            let enc = new TextDecoder('utf-8')
            let data = JSON.parse(enc.decode(new Uint8Array(res)))
            console.log(data)
            Message.error(data.msg)
        }catch (e) {
            let blob = new Blob([res], {
                type: "application/pdf;charset=utf-8"
            });
            FileSaver.saveAs(blob, name+".pdf");
        }
    }

    /**
     * 导出Excel文件
     * @param {*} res   文件流
     * @param {*} name  文件名
     */
    static getExcel(res, name) {

        try {
            let enc = new TextDecoder('utf-8')
            let data = JSON.parse(enc.decode(new Uint8Array(res)))
            console.log(data)
            Message.error(data.msg)
        }catch (e) {
            let blob = new Blob([res], {
                // type: "application/vnd.ms-excel"
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
            });
            // FileSaver.saveAs(blob, name + ".xls");
            FileSaver.saveAs(blob, name);
        }
    }

    /**
     * 导出CSV文件
     * @param {*} res   文件流
     * @param {*} name  文件名
     */
    static getCsv(res, name) {
        let blob = new Blob([res], {
            type: "application/vnd.ms-excel"
        });
        FileSaver.saveAs(blob, name + ".csv");
    }

    /**
     * 导出图片1
     * @param {*} url 图片地址
     * @param {*} name  文件名
     */
    static getImgURLs(url, name) {
        let last = url.substring(url.lastIndexOf("."), url.length);
        FileSaver.saveAs(url, `${name}${last}`);
    }
    /**
     * 导出图片2
     * @param {*} res 文件流
     * @param {*} name  文件名
     */
    static downLoadImg(res, filename) {

        try {
            let enc = new TextDecoder('utf-8')
            let data = JSON.parse(enc.decode(new Uint8Array(res)))
            console.log(data)
            Message.error(data.msg)
        }catch (e) {
            let blob = new Blob([res], {
                type: "image/jpeg"
            });
            FileSaver.saveAs(blob, `${filename}.jpg`);
        }
    }

    static showImg(res) {
        try {
            let enc = new TextDecoder('utf-8')
            let data = JSON.parse(enc.decode(new Uint8Array(res)))
            console.log(data)
            Message.error(data.msg)
        }catch (e) {
            let blob = new Blob([res], {
                type: "image/jpeg"
            });
            let href = URL.createObjectURL(blob)

            window.open(href,'_blank')
        }
    }


    static showPDFFile(res) {
        try {
            let enc = new TextDecoder('utf-8')
            let data = JSON.parse(enc.decode(new Uint8Array(res)))
            console.log(data)
            Message.error(data.msg)
        }catch (e) {
            let blob = new Blob([res], {
                type: "application/pdf;charset=utf-8"
            });
            let href = URL.createObjectURL(blob)

            window.open(href,'_blank')
            // FileSaver.saveAs(blob, name+".pdf");
        }
    }

    static fileSaver(res,filename) {
        FileSaver.saveAs(res, `${filename}.png`);
    }


}

